"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCoreData = getCoreData;
exports.getDashboardData = getDashboardData;
exports.getLeaseDashboardData = getLeaseDashboardData;
exports.getOrderStatusDistribution = getOrderStatusDistribution;
exports.getOverviewCards = getOverviewCards;
exports.getProductRank = getProductRank;
exports.getSalesCategoryDistribution = getSalesCategoryDistribution;
exports.getSalesRegionDistribution = getSalesRegionDistribution;
exports.getSalesTrend = getSalesTrend;
exports.getUserGrowth = getUserGrowth;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// 首页数据概览
function getDashboardData() {
  var timeRange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'today';
  return (0, _request.default)({
    url: "/admin/summary/dashboard?timeRange=".concat(timeRange),
    method: 'GET'
  });
}

// 核心数据
function getCoreData() {
  var timeRange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'today';
  return (0, _request.default)({
    url: "/admin/summary/core?timeRange=".concat(timeRange),
    method: 'GET'
  });
}

// 销售趋势
function getSalesTrend() {
  var timeRange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'today';
  return (0, _request.default)({
    url: "/admin/summary/sales-trend?timeRange=".concat(timeRange),
    method: 'GET'
  });
}

// 商品排行榜
function getProductRank() {
  var timeRange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'today';
  return (0, _request.default)({
    url: "/admin/summary/product-rank?timeRange=".concat(timeRange),
    method: 'GET'
  });
}

// 用户增长
function getUserGrowth() {
  var timeRange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'today';
  return (0, _request.default)({
    url: "/admin/summary/user-growth?timeRange=".concat(timeRange),
    method: 'GET'
  });
}

// 订单状态分布
function getOrderStatusDistribution() {
  var timeRange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'today';
  return (0, _request.default)({
    url: "/admin/summary/order-status?timeRange=".concat(timeRange),
    method: 'GET'
  });
}

// 新增：租赁看板数据（核心改造）
function getLeaseDashboardData() {
  var timeType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'day';
  return (0, _request.default)({
    url: "/admin/summary/lease-dashboard",
    method: 'GET',
    params: {
      timeType: timeType
    } // 使用params传递参数，更符合axios规范
  });
}

// 累计总览卡片：总销售额/总订单数/总用户数/总浏览量 + 近12个月按月趋势
function getOverviewCards() {
  return (0, _request.default)({
    url: "/admin/summary/overview-cards",
    method: 'GET'
  });
}

// 销售地区分布（饼图）
function getSalesRegionDistribution() {
  var timeRange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'today';
  return (0, _request.default)({
    url: "/admin/summary/sales-region?timeRange=".concat(timeRange),
    method: 'GET'
  });
}

// 销售分类分布（饼图）
function getSalesCategoryDistribution() {
  var timeRange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'today';
  return (0, _request.default)({
    url: "/admin/summary/sales-category?timeRange=".concat(timeRange),
    method: 'GET'
  });
}